/* import __COLOCATED_TEMPLATE__ from './icon-close-x.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--close-x'],
  viewBox: '1.5 1.5 13 13',
  width: 12,
  height: 12
});